const FieldControls = (target) => {
  const input = target.querySelector("input") as HTMLInputElement;
  const textarea = target.querySelector("textarea") as HTMLTextAreaElement;
  let el: HTMLInputElement | HTMLTextAreaElement | null = null;

  const method = {
    init: () => {
      if (input) {
        el = input;
      }
      if (textarea) {
        el = textarea;
      }

      el = input || textarea || null;

      if (el !== null) {
        el.addEventListener("blur", method.onBlur);
        el.addEventListener("focus", method.onFocus);
      }
    },
    onBlur: () => {
      el.classList.add("input--changed");
    },
    onFocus: () => {
      el.classList.remove("input--changed");
    },
  };

  method.init();
};

export default FieldControls;
